import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Star } from 'lucide-react';
import colors from '../theme/colors';
import { nailArtServices } from '../data/mock';
import { Button } from '../components/ui/button';

const NailArt = () => {
  return (
    <div style={{ backgroundColor: colors.background }} className="min-h-screen">
      {/* Header Section */}
      <section style={{ background: `linear-gradient(135deg, ${colors.white} 0%, ${colors.background} 100%)` }} className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 style={{ color: colors.primary }} className="text-5xl md:text-6xl font-bold mb-6">Nail Art Services</h1>
          <p style={{ color: colors.text.medium }} className="text-xl max-w-3xl mx-auto leading-relaxed">
            Professional nail art services that bring your vision to life. From elegant to bold, we create it all.
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 gap-8">
          {nailArtServices.map((service) => (
            <div 
              key={service.id}
              style={{ backgroundColor: colors.white }}
              className="rounded-2xl overflow-hidden shadow-lg transition-all duration-300 hover:shadow-2xl hover:scale-[1.02]"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                />
              </div>
              <div className="p-8">
                <div className="flex items-center space-x-3 mb-4">
                  <Star style={{ color: colors.highlight }} size={24} />
                  <h2 style={{ color: colors.primary }} className="text-3xl font-bold">{service.title}</h2>
                </div>
                <p style={{ color: colors.text.medium }} className="text-base mb-6 leading-relaxed">
                  {service.description}
                </p>
                <div className="space-y-2 mb-6">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center space-x-2">
                      <div style={{ backgroundColor: colors.highlight }} className="w-1.5 h-1.5 rounded-full"></div>
                      <span style={{ color: colors.text.medium }} className="text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
                <Link to="/contact">
                  <Button
                    style={{ backgroundColor: colors.highlight, color: colors.white }}
                    className="w-full py-5 text-base font-semibold rounded-full transition-all duration-300 hover:opacity-90"
                  >
                    Book This Service
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Custom Designs Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div 
          style={{ 
            background: `linear-gradient(135deg, ${colors.secondary} 0%, ${colors.highlight} 100%)`,
            color: colors.white 
          }}
          className="rounded-2xl p-12 text-center"
        >
          <Sparkles size={48} className="mx-auto mb-6" />
          <h3 className="text-4xl font-bold mb-6">Custom Designs Available!</h3>
          <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed opacity-95">
            Have a specific design in mind? We specialize in creating custom nail art tailored to your preferences. 
            Simply show us your inspiration, and we'll bring your vision to life with precision and creativity.
          </p>
          <div style={{ backgroundColor: 'rgba(255,255,255,0.2)' }} className="max-w-2xl mx-auto rounded-xl p-6 mb-8">
            <h4 className="text-xl font-semibold mb-4">How It Works:</h4>
            <div className="space-y-3 text-left">
              <div className="flex items-start space-x-3">
                <span className="font-bold text-2xl">1.</span>
                <span className="text-base">Share your design inspiration with us (photos, sketches, or ideas)</span>
              </div>
              <div className="flex items-start space-x-3">
                <span className="font-bold text-2xl">2.</span>
                <span className="text-base">We'll discuss your preferences and create a custom plan</span>
              </div>
              <div className="flex items-start space-x-3">
                <span className="font-bold text-2xl">3.</span>
                <span className="text-base">Watch us transform your nails into works of art!</span>
              </div>
            </div>
          </div>
          <Link to="/contact">
            <Button
              style={{ backgroundColor: colors.white, color: colors.primary }}
              className="px-8 py-6 text-lg font-semibold rounded-full transition-all duration-300 hover:opacity-90 hover:scale-105"
            >
              Request Custom Design
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default NailArt;